import usePoolState from '../../../context/pool/usePoolState';
import DepositInterface from './DepositInterface';
import PoolDepositOverview from './PoolDepositOverview';
import PoolOverview from './PoolOverview';
import WithdrawInterface from './WithdrawInterface';

const PoolOverviewContainer = () => {
    const { renderDepositInterface, renderWithdrawInterface } = usePoolState();

    return (
        <div className='pool-overview-container'>
            {renderWithdrawInterface ? <WithdrawInterface /> : <PoolOverview />}
            {renderDepositInterface ? <DepositInterface /> : <PoolDepositOverview />}
        </div>
    );
};

export default PoolOverviewContainer;
